import { baseMargin, baseMarginMultiplier } from './typography';
import palette from './palette';

const breakpoints = {
  mobile: 768,
  tablet: 1024,
};

export const MEDIA_QUERY_TYPES = {
  SMALLSCREEN: 'SMALLSCREEN',
  MOBILE: 'MOBILE',
  TABLET: 'TABLET',
};

const theme = {
  palette,
  margins: {
    xsmall: baseMargin / baseMarginMultiplier,
    small: baseMargin / (baseMarginMultiplier / 2),
    medium: baseMargin,
    large: baseMargin * (baseMarginMultiplier / 2),
    xlarge: baseMargin * baseMarginMultiplier,
  },
  media: {
    breakpoints,
    ranges: {
      [MEDIA_QUERY_TYPES.MOBILE]: {
        max: breakpoints.mobile,
      },
      [MEDIA_QUERY_TYPES.TABLET]: {
        min: breakpoints.mobile,
        max: breakpoints.tablet,
      },
      [MEDIA_QUERY_TYPES.SMALLSCREEN]: {
        max: breakpoints.tablet,
      },
    },
  },
};

export const mediaQuery = ({ type }) => {
  const typeData = theme.media.ranges[type];
  if (!typeData) return null;
  const { max, min } = typeData;
  let query = '';
  if (max) {
    query += `max-width: ${max}px`;
  }
  if (min) {
    query += `min-width ${min}px`;
  }
  return `@media (${query})`;
};

// pre-defined queries
export const mediaQuerySmallScreen = mediaQuery({
  type: MEDIA_QUERY_TYPES.SMALLSCREEN,
});
export const mediaQueryMobile = mediaQuery({ type: MEDIA_QUERY_TYPES.MOBILE });
export const mediaQueryTablet = mediaQuery({ type: MEDIA_QUERY_TYPES.TABLET });

export default theme;
